import React from "react";

/**
 * Placeholder for leave history / approval status (hook to APIs later).
 */
export function EssMyRequestsTab() {
  return (
    <div className="text-muted small">
      Leave requests and statuses will appear here once connected to your HRMS
      backend.
    </div>
  );
}
